import React, { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './authentication.scss';

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [pageReady, setPageReady] = useState(false);

  useEffect(() => {
    if (!token) {
      setError('❌ Invalid or missing reset token');
    } else {
      setPageReady(true);
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    // Validation
    if (!password) {
      setError('⚠️ Password is required');
      return;
    }

    if (password.length < 6) {
      setError('⚠️ Password must be at least 6 characters');
      return;
    }

    if (password !== confirmPassword) {
      setError('⚠️ Passwords do not match');
      return;
    }

    try {
      setLoading(true);
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      
      const response = await axios.post(`${apiUrl}/test-reset-token`, {
        token,
        newPassword: password
      });

      if (response.data.status === 200 || response.status === 200) {
        setSuccess('✅ Password reset successfully! Redirecting...');
        setTimeout(() => navigate('/'), 2000);
      }
    } catch (err) {
      console.error('Reset error:', err);
      const msg = err.response?.data?.message || 'Failed to reset password';
      setError(`❌ ${msg}`);
    } finally {
      setLoading(false);
    }
  };

  if (!pageReady) {
    return (
      <div className="reset-password-page">
        <div className="reset-container">
          <div className="reset-error">
            <h2>❌ Invalid Reset Link</h2>
            <p>The reset link is invalid or has expired.</p>
            <a href="/" className="btn-home">Go Back Home</a>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="reset-password-page">
      <div className="reset-container">
        <div className="reset-card">
          <div className="reset-header">
            <h1>🔐 Reset Your Password</h1>
            <p>Enter your new password below</p>
          </div>

          {error && <div className="alert alert-error">{error}</div>}
          {success && <div className="alert alert-success">{success}</div>}

          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="password">New Password</label>
              <input
                type="password"
                id="password"
                placeholder="Enter new password (min 6 characters)"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                disabled={loading}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm Password</label>
              <input
                type="password"
                id="confirmPassword"
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                disabled={loading}
                required
              />
            </div>

            <button type="submit" className="btn-submit" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password'}
            </button>

            <div className="form-footer">
              <p>Remember your password? <a href="/">Back to Home</a></p>
            </div>
          </form>

          <div className="security-tips">
            <h4>🛡️ Security Tips:</h4>
            <ul>
              <li>Use a strong password</li>
              <li>Never share your password</li>
              <li>Use unique passwords for each account</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
